import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {useAppSelector} from 'utils/hooks';

import {IStore} from 'store/store';
import {showPopup} from 'store/components/PopupSlice';
import {GetIcon} from 'store/enums/normalizedIcons';

import AuthorizedMenu from './assets/components/authorizedMenu/AuthorizedMenu';
import ButtonContainer from './assets/components/buttonContainer/ButtonContainer';
import Link from 'components/link/Link';
import IconSprite from 'components/IconSprite/IconSprite';

import logoIcons from './assets/images/logoIconsSprite.svg';

import './Header.scss';

interface IHeader {
  marginBottom?: string | number;
  setShowMobileButton?: (A: boolean) => any;
  showMobileButton?: boolean;
  backgroundColorUnAuthorized?: string;
}

const Header: React.FC<IHeader> = ({marginBottom, showMobileButton, setShowMobileButton, backgroundColorUnAuthorized}) => {
  const w = window;
  const href = w.location.href;

  const dispatch = useDispatch();
  const history = useHistory();

  const [prevScrollPosition, setPrevScrollPosition] = useState(0);
  const [headerTop, setHeaderTop] = useState('show');

  const headerRef = useRef<HTMLElement>();

  const colors = useSelector((state: IStore) => state.settings.colors);
  const user = useSelector((state: IStore) => state.auth.user);
  const domain = useSelector((state: IStore) => state.settings.currentDomainName);
  const authorized = useSelector((state: IStore) => state.auth.authorized);
  const currentDomainName = useAppSelector((state) => state.settings.currentDomainName);

  const openMainPage = () => {
    authorized ? history.push('prizes') : history.push('/');
  };

  const logos: {[key: string]: any} = {
    'makfa': {desktop: 'logoMakfa', mobile: 'logoMakfa'},
    'smeg': {desktop: 'smakLogo', mobile: 'smakLogo'},
    'rus-exp': {desktop: 'ruex', mobile: 'ruex'},
    'default': {desktop: 'logo', mobile: 'logo'},
    'mtsfirst': {desktop: 'logo', mobile: 'logo'},
    'loto': {desktop: 'logo', mobile: 'logo'},
    'asgbonus': {desktop: 'logo', mobile: 'logo'},
    'leader-abc': {desktop: 'leader_abc_logo', mobile: 'leader_abc_logo'},
    'mascoglass': {desktop: 'logo_mascoglass', mobile: 'logo_mascoglass'},
    'pharmacy-366': {desktop: 'pharmacy366Logo', mobile: 'pharmacy366Logo'},
    'birthday': {desktop: 'logo', mobile: 'logo'},
    'local': {desktop: 'logo', mobile: 'logo'},
    'men-day': {desktop: 'logo', mobile: 'logo'},
    'womens-day': {desktop: 'logo', mobile: 'logo'},
    'gdnprof': {desktop: 'logo', mobile: 'logo'},
    'rtmis': {desktop: 'logo', mobile: 'logo'},
    'stg': {desktop: 'StgLogo', mobile: 'StgLogoMobile'},
    'geo': {desktop: 'logo', mobile: 'logo'},
    'rubin': {desktop: 'rubinLogo', mobile: 'rubinLogo'},
    'brucite': {desktop: 'logo', mobile: 'logo'},
    'raiffeisen': {desktop: '', mobile: ''},
    'sargazarm': {desktop: 'logo', mobile: 'logo'},
    'proektirovanie': {desktop: 'logo', mobile: 'logo'},
    'aclub': {desktop: 'AClubLogo', mobile: 'AClubLogo'},
    'loto-pr': {desktop: 'logoLotoPr', mobile: 'logoLotoPr'},
    'mts-mission': {desktop: 'MTSMissionLogo', mobile: 'MTSMissionLogo'},
    'megafon': {desktop: 'Megafonlogo', mobile: 'Megafonlogo'},
    'beeline': {desktop: 'logo', mobile: 'logo'},
  };

  const statuses = [
    'empty',
    'moderate',
    'approve',
    'reject',
  ];

  const openJivo = () => {
    // @ts-ignore
    jivo_api.open();
    return false;
  };

  useEffect(() => {
    const handleScroll = () => {
      const position = w.pageYOffset;
      if (prevScrollPosition > position || position < 30) {
        setHeaderTop('show');
      } else if (prevScrollPosition < position){
        setHeaderTop('hide');
      }
      if (headerRef.current) {
        if (position > 15) {
          headerRef.current.style.backgroundColor = authorized
            ? 'rgba(255, 255, 255)'
            : backgroundColorUnAuthorized
              ? backgroundColorUnAuthorized
              : 'rgba(255, 251, 248, 0.96)';
          headerRef.current.style.boxShadow = authorized ? '' : 'rgb(226 226 226) 0px 1px 20px -6px';
          if (position > 30 && setShowMobileButton) {
            setShowMobileButton(true);
          }
        } else {
          headerRef.current.style.backgroundColor = authorized ? '#fff' : 'transparent';
          headerRef.current.style.boxShadow = '';

          setShowMobileButton && setShowMobileButton(false);
        }
      }

      setPrevScrollPosition(position);
    };
    w.addEventListener('scroll', handleScroll);

    return () => {
      w.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPosition]);

  useEffect(() => {
    w.scrollTo(0, 0);
  }, [history.location]);

  const inlineStyleHeader = {
    marginBottom: marginBottom,
    backgroundColor: authorized ? '#fff' : 'transparent',
    zIndex: 5,
  };

  const openAuthPopup = () => {
    dispatch(showPopup('auth'));
  };

  const openPage = (e: any, path: string) => {
    e.stopPropagation();
    history.push(path);
  };

  const openCheckCard = () => {
    dispatch(showPopup('checkCard'));
  };

  const openMenu = () => {
    dispatch(showPopup('burgerMenu'));
  };

  return (
    // @ts-ignore
    <header ref={headerRef} className={'header'}  style={inlineStyleHeader}>
      <div
        className={[
          'header__container',
          authorized
            ? 'header__container_row-reverse'
            : 'header__container_row'
        ].join(' ')}>
        {
          authorized
            ? <AuthorizedMenu />
            : (
              <span className={'menu__burger'} onClick={openMenu}>
                <GetIcon
                  iconName={'BurgerMainMenu'}
                  fill={colors[domain].firstColorIconIdle}
                  secondaryFill={colors[domain].secondColorIconIdle}
                />
              </span>
            )
        }

        {
          logos[currentDomainName].desktop ? (
            <>
              <div  className={'header__logo-container'} onClick={openMainPage}>
                <IconSprite id={logos[currentDomainName].mobile} sprite={logoIcons} className={'header__logo header__logo_mobile'} />
              </div>
              <IconSprite 
                id={logos[currentDomainName].desktop} 
                sprite={logoIcons}
                className={'header__logo header__logo_desktop'} 
                onClick={openMainPage} 
              />
            </>
          ) : null 
        }
        {
          authorized
            ? (
              <div className={'header__link-icon'}>
                {
                  user?.tax ? (
                    <div
                      className={`
                        authorizes-menu__ndfl 
                        authorizes-menu__ndfl-animation_${user?.tax ? statuses[user.tax.status] : ''} 
                        menu-cart
                      `}
                      onClick={(e) => openPage(e, 'profile#ndfl')}>
                      <span className={'menu-cart__image'}>
                        <GetIcon
                          iconName={'ClipBoard'}
                          opacity={colors[domain].cartIconOpacity}
                          fill={colors[domain].firstColorIconIdle}
                          secondaryFill={colors[domain].secondColorIconIdle}
                        />
                      </span>
                      <div
                        className={`
                          authorizes-menu__ndfl-status
                          authorizes-menu__ndfl-status_${user?.tax ? statuses[user?.tax?.status] : 'empty'}
                        `} />
                    </div>
                  ) : null
                }
                {
                  <Link 
                    img={href.includes('profile') || domain === 'leader-abc'
                      ? (
                        <GetIcon
                          iconName={'User'}
                          fill={colors[domain].firstColorIconActive}
                          secondaryFill={colors[domain].secondColorIconActive}
                          opacity={colors[domain].tabMenu.opacity}
                          className={href.includes('profile') ? 'header__icon-user_active' : ''}
                        />
                      ) : (
                        <GetIcon
                          iconName={'User'}
                          fill={colors[domain].firstColorIconIdle}
                          secondaryFill={colors[domain].secondColorIconIdle}
                        />
                      )}
                    onClick={(e: any) => openPage(e, 'profile')} 
                  />
                }
              </div>
            ) : (
              <>
                <ButtonContainer openJivo={openJivo} />
                <div className={'header__link-group'}>
                  <div onClick={openCheckCard} className={'header__link-icon'}>
                    <GetIcon
                      iconName={'Card'}
                      fill={colors[domain].firstColorIconIdle}
                      secondaryFill={colors[domain].secondColorIconIdle}
                    />
                  </div>
                </div>
              </>
            )
        }
      </div>
    </header>
  );
};

export default Header;
